import {Check} from 'lucide-react';
import {cn} from '@common-web/lib/utils';

export function CheckRow({
  label,
  checked,
  disabled,
  onToggle,
}: {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onToggle?: () => void;
}) {
  return (
    <button
      type='button'
      role='checkbox'
      aria-checked={checked}
      aria-disabled={disabled}
      onClick={disabled ? undefined : onToggle}
      className={cn(
        'flex h-8 w-full min-w-0 items-center gap-2 rounded-lg px-2 text-left text-sm',
        disabled ? 'cursor-default text-gray-500' : 'text-gray-900 hover:bg-gray-100',
      )}
    >
      <span
        className={cn(
          'inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-[4px]',
          checked
            ? disabled
              ? 'bg-gray-500'
              : 'bg-gray-900'
            : 'border-[1.5px] border-gray-300 bg-white',
        )}
      >
        {checked && <Check className='h-[11px] w-[11px] text-white' strokeWidth={3} />}
      </span>
      <span className='truncate'>{label}</span>
    </button>
  );
}
